import { render, staticRenderFns } from "./TemplatePrimaryListingItem.vue?vue&type=template&id=dcf2793e&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./TemplatePrimaryListingItem.vue?vue&type=script&lang=js&"
export * from "./TemplatePrimaryListingItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Data\\TeamCity\\buildAgent\\work\\6dffdb6616650f37\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dcf2793e')) {
      api.createRecord('dcf2793e', component.options)
    } else {
      api.reload('dcf2793e', component.options)
    }
    module.hot.accept("./TemplatePrimaryListingItem.vue?vue&type=template&id=dcf2793e&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&", function () {
      api.rerender('dcf2793e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/TemplateManager/Components/Listings/TemplatePrimaryListingItem.vue"
export default component.exports